import styled from 'styled-components';
import ReactCanvasConfetti from 'react-canvas-confetti';

export const CanvasConfettiContainer = styled(ReactCanvasConfetti)`
  pointer-events: none;
  width: 100%;
  height: 100%;
`;
CanvasConfettiContainer.displayName = 'CanvasConfettiContainer';
